<template>
    <div class="contact-us">
        <div class="contact-us--container">
            <div class="contact-us--ourFlowers">
                <p class="contact-us--title">{{$t('CONTACT_US_OUR_FLOWERS')}}</p>
                <div class="contact-us--links">
                    <p><router-link class="contact-us--link" :to="{name: 'flowers'}">{{$t('LANDING_FLOWERS')}}</router-link></p>
                    <p><router-link class="contact-us--link" :to="{name: 'arranging'}">{{$t('LANDING_ARRANGING')}}</router-link></p>
                    <p><router-link class="contact-us--link" :to="{name: 'delivery'}">{{$t('LANDING_DELIVERY')}}</router-link></p>
                    <p><router-link class="contact-us--link" :to="{name: 'sustainability'}">{{$t('CONTACT_US_NAV_LINK_SUSTAINABILITY')}}</router-link></p>
                </div>
            </div>
            <div class="contact-us--company">
                <p class="contact-us--title">{{$t('CONTACT_US_COMPANY')}}</p>
                <div class="contact-us--links">
                    <p>
                        <router-link :to="{ name: 'blog' }" class="contact-us--link" target="_blank">
                            <div @click="$emit('closed')">
                                {{ $t('CONTACT_US_BLOG') }}
                            </div>
                        </router-link>
                    </p>
                    <p>
                        <router-link :to="{ name: 'jobs' }" class="contact-us--link">
                            <div @click="$emit('closed')">
                                {{ $t('CONTACT_US_JOBS') }}
                            </div>
                        </router-link>
                    </p>
                    <p>
                        <router-link :to="{ name: 'survey-entrants' }" target="_blank" class="contact-us--link">
                            <div @click="$emit('closed')">
                                {{ $t('CONTACT_US_SURVEY_ENTRANTS') }}
                            </div>
                        </router-link>
                    </p>
                    <p>
                        <router-link :to="{ name: 'tag-rugby-trust' }" class="contact-us--link">
                            <div @click="$emit('closed')">
                                {{ $t('CONTACT_US_TRT_PAGE') }}
                            </div>
                        </router-link>
                    </p>
                </div>
            </div>
            <div class="contact-us--needHelp">
                <p class="contact-us--title">{{$t('HAMBURGER_HELP')}}</p>
                <div class="contact-us--links">
                    <p>
                        <a class="contact-us--link" :href="countryUtils.zendesk_hc_url" :target="isUserLoggedIn ? '_self' : '_blank'">
                            {{ $t('CONTACT_US_HELP_CENTER') }}
                            <img class="contact-us--icon" :src="openInNewTab" alt="Open in Tew Tab icon" v-if="!isUserLoggedIn">
                        </a>
                    </p>
                    <p>
                        <a class="contact-us--link" :href="countryUtils.zendesk_hc_my_account_url" :target="isUserLoggedIn ? '_self' : '_blank'">
                            {{ $t('CONTACT_US_HELP_CENTER_MY_ACCOUNT') }}
                            <img class="contact-us--icon" :src="openInNewTab" alt="Open in Tew Tab icon" v-if="!isUserLoggedIn">
                        </a>
                    </p>
                    <p>
                        <a class="contact-us--link" :href="countryUtils.zendesk_hc_my_delivery_url" :target="isUserLoggedIn ? '_self' : '_blank'">
                            {{ $t('CONTACT_US_HELP_CENTER_DELIVERIES') }}
                            <img class="contact-us--icon" :src="openInNewTab" alt="Open in Tew Tab icon" v-if="!isUserLoggedIn">
                        </a>
                    </p>
                </div>
            </div>
            <div class="contact-us--legal">
                <p class="contact-us--title">{{$t('CONTACT_US_LEGAL')}}</p>
                <div class="contact-us--links">
                    <p>
                        <a href="#" class="contact-us--link">
                            <div @click="showCookieBanner()">
                                {{ $t('CONTACT_US_COOKIE') }}
                            </div>
                        </a>
                    </p>
                    <p>
                        <router-link :to="{ name: 'terms-and-conditions' }" class="contact-us--link">
                            <div @click="$emit('closed')">
                                {{ $t('CONTACT_US_TERMS') }}
                            </div>
                        </router-link>
                    </p>
                    <p>
                        <router-link :to="{ name: 'privacy-policy' }" class="contact-us--link">
                            <div @click="$emit('closed')">
                                {{ $t('CONTACT_US_PRIVACY') }}
                            </div>
                        </router-link>
                    </p>
                    <p>
                        <router-link :to="{ name: 'accessibility' }" class="contact-us--link">
                            <div @click="$emit('closed')">
                                {{ $t('CONTACT_US_ACCESSIBILITY') }}
                            </div>
                        </router-link>
                    </p>
                </div>
            </div>
        </div>

        <div class="contact-us--infoSection">
            <div class="contact-us--socialLinks">
                <a class="mx-2" href="https://www.facebook.com/Freddiesflowers" target="_blank">
                    <img class="hamburger__socialIcon"
                        src="@/assets/images/decoration/social-icon-facebook.png"
                        alt="Facebook">
                </a>

                <a class="mx-2" href="https://www.instagram.com/freddiesflowers" target="_blank">
                    <img class="hamburger__socialIcon"
                        src="@/assets/images/decoration/social-icon-instagram.png"
                        alt="Instagram">
                </a>
            </div>
            <div class="contact-us--countrySelector">
                <country-switch-dropdown
                    :showFullName="true"
                    :showBorder="true"
                    optionsDirection="top"/>
            </div>
            <div class="contact-us--copyRights">
                <p>&copy; {{$t('CONTACT_US_COPYRIGHT')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CountrySwitchDropdown from '@/components/structure/navigation/CountrySwitchDropdown';
import OpenInNewTab from '@/assets/icons/open-in-new-tab.png';
import countryUtils from '@/resources/countryUtils.json';

export default {
    name: 'ContactUs',
    data() {
        return {
            countryUtils: countryUtils.filter(item => item.locale.toLowerCase() === process.env.VUE_APP_DATE_LOCALE.toLowerCase())[0],
            phone: process.env.VUE_APP_TELEPHONE,
            openInNewTab: OpenInNewTab,
        };
    },
    components: {
        CountrySwitchDropdown,
    },
    props: {
        faqsLink: {
            required: false,
            default: false,
            type: Boolean,
        },
    },
    computed: {
        ...mapGetters({
            isUserLoggedIn: 'auth/isUserLoggedIn',
        }),
    },
    methods: {
        showCookieBanner() {
            this.$store.commit('cookies/showCookieBanner');
        },
    },
};
</script>
<style lang="scss" scoped>
.contact-us {
    .contact-us--container{
        display: grid;
        grid-template-columns: 1fr 1fr;
        width: 80%;
        margin: 60px auto;
        margin-bottom: 30px;
        @media screen and (min-width: 720px) {
            width: 70%;
            grid-template-columns: repeat(4, 1fr);
            justify-content: space-around;
        }
    }
    &--company, &--needHelp, &--legal, &--ourFlowers {
        margin: 0 20px;
        font-size: 16px;
    }
    &--links {
        overflow: hidden;
        p {
            font-size: 16px;
        }
    }
    &--title {
        font-weight: 400;
        font-size: 16px;
    }
    &--link {
        font-size: 16px;
        &:hover {
            cursor: pointer;
            text-decoration: underline;
        }
    }
    &--icon {
        display: inline;
        width: 10px;
    }
    &--socialLinks {
        margin: 20px 10px;
        display: flex;
    }
    &--countrySelector {
        margin: 10px;
    }
    &--infoSection {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    &--copyRights p {
        font-size: 16px;
    }
}
</style>
